import { Colors } from '~/themes/colors';
import { IIconProps } from './Types';

export const ExternalLinkIcon = ({ color = Colors.primary_500, size = 24 }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.2016 3.59998C12.5388 3.59998 12.0016 4.13723 12.0016 4.79998C12.0016 5.46272 12.5388 5.99998 13.2016 5.99998H16.3045L8.75303 13.5514C8.28441 14.0201 8.28441 14.7799 8.75303 15.2485C9.22166 15.7171 9.98146 15.7171 10.4501 15.2485L18.0016 7.69703V10.8C18.0016 11.4627 18.5388 12 19.2016 12C19.8643 12 20.4016 11.4627 20.4016 10.8V4.79998C20.4016 4.13723 19.8643 3.59998 19.2016 3.59998H13.2016Z"
        fill={color}
      />
      <path
        d="M6.00156 5.99998C4.67608 5.99998 3.60156 7.07449 3.60156 8.39998V18C3.60156 19.3255 4.67608 20.4 6.00156 20.4H15.6016C16.927 20.4 18.0016 19.3255 18.0016 18V14.4C18.0016 13.7372 17.4643 13.2 16.8016 13.2C16.1388 13.2 15.6016 13.7372 15.6016 14.4V18H6.00156V8.39998L9.60156 8.39998C10.2643 8.39998 10.8016 7.86272 10.8016 7.19998C10.8016 6.53723 10.2643 5.99998 9.60156 5.99998H6.00156Z"
        fill={color}
      />
    </svg>
  );
};
